import { render, staticRenderFns } from "./WizardForm.vue?vue&type=template&id=64d4e8ae&scoped=true&"
import script from "./WizardForm.vue?vue&type=script&lang=ts&"
export * from "./WizardForm.vue?vue&type=script&lang=ts&"
import style0 from "./WizardForm.vue?vue&type=style&index=0&id=64d4e8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4e8ae",
  null
  
)

export default component.exports